import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getUpcomingExpiries } from '../../services/api';

const UpcomingLicenseExpiry = () => {
    const [expiries, setExpiries] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchExpiries = async () => {
            setLoading(true);
            try {
                const data = await getUpcomingExpiries({
                    limit: 5,  // Get top 5 upcoming expiries
                    days_ahead: 30  // Look ahead 30 days
                });
                setExpiries(Array.isArray(data) ? data : []);
            } catch (error) {
                console.error('Error fetching upcoming expiries:', error);
                setExpiries([]);  // Ensure we always set an array to prevent undefined errors
            } finally {
                setLoading(false);
            }
        };

        fetchExpiries();
    }, []);

    const getDaysRemaining = (expiryDate) => {
        const today = new Date();
        const expiry = new Date(expiryDate);
        const diffTime = expiry - today;
        return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    };

    const getStatusClass = (days) => {
        if (days <= 7) return 'bg-danger-100 text-danger';
        if (days <= 30) return 'bg-warning-100 text-warning';
        return 'bg-success-100 text-success';
    };

    if (loading) {
        return (
            <div className="col-xxl-4">
                <div className="card">
                    <div className="card-body text-center py-4">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="col-xxl-4">
            <div className="card h-100">
                <div className="card-body">
                    <div className="d-flex align-items-center flex-wrap gap-2 justify-content-between">
                        <h6 className="mb-2 fw-bold text-lg mb-0">Upcoming License Expiry</h6>
                        <Link
                            to="/admin/licenses"
                            className="text-primary-600 hover-text-primary d-flex align-items-center gap-1 text-decoration-none"
                        >
                            View All
                            <Icon
                                icon="solar:alt-arrow-right-linear"
                                className="icon ms-1"
                                width="16"
                                height="16"
                            />
                        </Link>
                    </div>
                    <div className="mt-3">
                        {expiries.length > 0 ? (
                            expiries.map((item, index) => {
                                const daysRemaining = getDaysRemaining(item.expiry_date);
                                const statusClass = getStatusClass(daysRemaining);
                                
                                return (
                                    <div key={index} className="d-flex align-items-center justify-content-between gap-3 mb-3">
                                        <div className="d-flex align-items-center flex-grow-1">
                                            <div className="flex-shrink-0 me-3">
                                                <div className="avatar-sm">
                                                    <div className={`avatar-title rounded-circle ${statusClass} fs-12`}>
                                                        <Icon icon="solar:calendar-date-linear" className="fs-5" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="flex-grow-1">
                                                <h6 className="mb-0 text-sm">{item.company_name || 'N/A'}</h6>
                                                <p className="text-muted mb-0 font-xs">
                                                    {item.license_type || 'Standard License'}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="text-end">
                                            <span className={`badge ${statusClass} py-1 px-2`}>
                                                {daysRemaining > 0 ? `${daysRemaining}d left` : 'Expired'}
                                            </span>
                                            <p className="text-muted mb-0 mt-1 font-xs">
                                                {new Date(item.expiry_date).toLocaleDateString()}
                                            </p>
                                        </div>
                                    </div>
                                );
                            })
                        ) : (
                            <div className="text-center py-4">
                                <Icon icon="solar:shield-warning-linear" className="text-muted mb-2" width={24} />
                                <p className="text-muted mb-0">No upcoming license expiries</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UpcomingLicenseExpiry;